import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/PatientSlice";

import { constants } from "../../constants/common";
import { common } from "../../types";

import API from "../../services/rest/api";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

const GetPatientDetailsRequest = function* GetPatientDetailsRequest({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetPatientDetails,
      payload
    );
    // The page payload comes from chief_hc, which does not carry plan_status.
    // PAUSE lives on healthcoach/patient_details_by_id — read it from there.
    let healthcoachPlanStatus: string | null | undefined;
    try {
      const healthcoachResponse: common.ResponseGenerator = yield call(
        API.GetPatientData,
        { patient_id: payload?.patient_id }
      );
      if (Number(healthcoachResponse?.code) === 1) {
        healthcoachPlanStatus = healthcoachResponse?.data?.plan_status;
      }
    } catch {
      healthcoachPlanStatus = undefined;
    }
    if (Number(response.code) === 1) {
      const data = {
        ...response.data,
        plan_status:
          healthcoachPlanStatus ?? response.data?.plan_status ?? null,
      };
      yield put(actions.patientDetailsSuccess({ ...response, data }));
      resolve({ ...response, data });
    } else if (Number(response.code) === -1) {
      throw new Error("Session Expire");
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    yield put(
      actions.getPatientDetailsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    // reject(error);
  }
};


const GetPatientDetailsById = function* GetPatientDetailsById(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetPatientVisitDetails,
      action.payload
    );
    if (Number(response.code) === 1) {
      yield put(actions.patientDetailsByIdSuccess(response));
    } else {
      const ErrorMessage = response.message || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(
        actions.getPatientDetailsByIdError(
          ErrorMessage
        )
      );
      toast.error(ErrorMessage);
    }
  } catch (error) {
    const ErrorMessage = error instanceof Error
      ? error?.message
      : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(
      actions.getPatientDetailsByIdError(
        ErrorMessage
      )
    );
    toast.error(ErrorMessage);
  }
};

export default function* patientSaga() {
  yield all([
    takeEvery(actions.getPatientDetailsRequest, GetPatientDetailsRequest),
    takeEvery(actions.getPaitientDetailsByIdRequest, GetPatientDetailsById),
  ]);
}
